module.exports = __webpack_public_path__ + "img/Artscene_Logo.2dd6bf6e.jpeg";